export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-ghost-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading font-bold text-lg text-foreground-100">妖精动漫网</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4 max-w-md">
              妖精动漫网是一个免费的漫画在线阅读平台，提供海量免费漫画大全。支持下拉式阅读，每日同步更新热门连载。无论你是热血少年还是恋爱少女，都能在这里找到属于你的精神食粮。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center cursor-pointer transition-colors duration-200 hover:bg-primary-500">
                <i className="ri-arrow-up-line text-foreground-300"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-foreground-100 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#hero" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</a>
              <a href="#index" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门排行榜</a>
              <a href="#faq" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer">常见问题</a>
              <a href="#contact" className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 cursor-pointer">联系我们</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-foreground-500 text-xs leading-relaxed">更多合作伙伴即将入驻，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-foreground-500">
          <p>© 2026 妖精动漫网 - 免费漫画在线阅读平台</p>
          <div className="flex items-center gap-4">
            <span>免费漫画</span>
            <span>·</span>
            <span>在线阅读</span>
            <span>·</span>
            <span>下拉式</span>
            <span>·</span>
            <span>漫画大全</span>
          </div>
        </div>
      </div>
    </footer>
  );
}